<template>
    <div>
        <div class="app-main__inner">
            <TituloComponente icono-titulo="fas fa-clipboard-list" texto-titulo="Editar Perfil" />
            <div class="tab-content">
                <div class="tab-pane tabs-animation fade show active" id="tab-content-0" role="tabpanel">
                    <div class="row">
                        <div class="col-lg-12">
                            <div class="main-card mb-3 card">
                                <div class="card-body">
                                    <h5 class="card-title">Modificar Password</h5>
                                    <form @submit.prevent="guardarPass()">
                                    <float-label label="Password anterior:" clase>
                                        <input v-model="usuario.password" id="descripcion" placeholder="Ingresar Password..." type="password" class="form-control" :class="(enviado && !$v.usuario.password.distintos) ? 'is-invalid' : ''" />
                                        <template v-slot:validation>
                                        <div class="invalid-feedback" v-if="enviado && !$v.usuario.password.distintos">Contraseña invalida</div>
                                        </template>
                                    </float-label>
                                    <float-label label="Nueva password:" clase>
                                        <input v-model="usuario.newPassword" id="descripcion" placeholder="Ingresar Password..." type="password" class="form-control" :class="(enviado && !$v.usuario.newPassword.required) ? 'is-invalid' : ''" />
                                        <template v-slot:validation>
                                        <div class="invalid-feedback" v-if="enviado && !$v.usuario.newPassword.required">El campo no puede estar vacio</div>
                                        </template>
                                    </float-label>
                                    <float-label label="Repetir password:" clase>
                                        <input v-model="usuario.repetirPassword" id="descripcion" placeholder="Ingresar Password..." type="password" class="form-control" :class="(enviado && !$v.usuario.repetirPassword.sameAsPassword) ? 'is-invalid' : ''" />
                                        <template v-slot:validation>
                                        <div class="invalid-feedback" v-if="enviado && !$v.usuario.repetirPassword.sameAsPassword">Debe coincidir con la Password</div>
                                        </template>
                                    </float-label>
                                    <button class="mt-2 btn btn-info float-right">Guardar</button>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>                               
        </div>
    </div>
</template>
<script>
import TituloComponente from '@/components/layouts/TituloComponente';
import { required, sameAs } from 'vuelidate/lib/validators';
import FloatLabel from "@/components/layouts/FloatLabel";
import Vuex from "vuex";
import Swal from "sweetalert2";
import axios from "axios";
export default {
    name: "EditarPerfil",
    components: {
        TituloComponente,
        FloatLabel,
    },
    validations:{
        usuario:{
            password:{ 
                distintos: sameAs('oldPassword')
            },
            newPassword:{required//,
                //distintos: not(sameAs('password')) 
                },
            repetirPassword:{
                sameAsPassword: sameAs('newPassword')
            }
        }
    },
    data(){
        return {
            usuario: [],
            enviado:false,
            //oldPassword:null
        }
    },
    computed:{
        ...Vuex.mapState(['user', 'credentials']),
    },
    created(){
    },
    mounted(){
        this.obtenerUsuario();
    },
    methods:{
        obtenerUsuario(){
            this.usuario = this.user;
            this.usuario.oldPassword = this.credentials.password;
            console.log(this.usuario);
        },
        guardarPass(){
            this.enviado = true
            this.$v.$touch();
            console.log( this.usuario.newPassword + "asdasd" + this.usuario.repetirPassword)
            if(this.usuario.newPassword != this.usuario.repetirPassword){
                return false;
            }
            if(this.usuario.oldPassword != this.usuario.password){
                Swal.fire({
                    icon: "error",
                    title: "Oopss..",
                    text: `La contraseña ingresada es invalida.`
                });
                return false;
            }
            if(this.$v.$invalid){
                this.loading = false;
                return false;
            }
            axios
            .post("/user/edit", this.usuario)
            .then(res => {
            if (res.data.success) {
                Swal.fire({
                icon: "success",
                title: "Éxito",
                text: `La contraseña se cambió con éxito.`
                });
                this.$router.go(-1);
            }
            })
            .catch(error => {
            console.log(error);
            Swal.fire({
                icon: "error",
                title: "Oopss..",
                text: `No se ha podido completar la operación.`
            });
            })
            .finally(() => (this.loading = false));
        }
    },
}
</script>
